import { checkIfValidUUID } from 'utils/functions';
import { useTheme } from '@mui/material/styles';
import Chip, { ChipColor } from 'ui-component/extended/Chip';
import {
  Icon,
  IconMicroscope,
  IconCamera,
  IconCut,
  IconArrowsJoin,
  IconDisc,
  IconDropletOff,
  IconTransferIn,
  IconTallymarks,
  IconTrash,
  IconBuildingStore,
  IconPlaneDeparture,
  IconBox,
} from '@tabler/icons-react';
import { Tooltip } from '@mui/material';

export interface RequiredShipmentProps {
  id: string;
  shipmentCode: string;
}

export interface PickTypeIndicatorProps {
  pickType: string;
  shipments?: RequiredShipmentProps[] | null;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large' | undefined;
}

const pickTypeIcons: { [key: string]: Icon } = {
  msl_reset: IconDropletOff,
  combine: IconArrowsJoin,
  reel: IconDisc,
  inspection: IconMicroscope,
  split: IconCut,
  transfer: IconTransferIn,
  check_quant: IconTallymarks,
  dispose: IconTrash,
  package_photo: IconCamera,
  resell: IconBuildingStore,
  ship: IconPlaneDeparture,
  kit: IconBox,
};

const PickTypeIndicator = ({
  pickType,
  shipments,
  disabled = false,
  size = undefined,
}: PickTypeIndicatorProps) => {
  const theme = useTheme();

  if (!pickType) return <></>;

  if (pickType in pickTypeIcons) {
    const PickIcon = pickTypeIcons[pickType];
    return (
      <Tooltip title={`${disabled ? 'Draft' : 'Requested'} handling task`}>
        <span style={{ lineHeight: 0 }}>
          <PickIcon
            stroke="1.5px"
            color={
              disabled ? theme.palette.grey[500] : theme.palette.secondary.main
            }
            size={size ? { small: 16, medium: 24, large: 36 }[size] : undefined}
          />
        </span>
      </Tooltip>
    );
  }
  if (checkIfValidUUID(pickType)) {
    const shipmentCode = shipments?.find(
      (s) => s.id === pickType
    )?.shipmentCode;
    if (shipmentCode) {
      return (
        <Tooltip title={`${disabled ? 'Draft' : 'Requested'} shipment`}>
          <span>
            <Chip
              label={shipmentCode}
              chipcolor={disabled ? ChipColor.grey : ChipColor.secondary}
            />
          </span>
        </Tooltip>
      );
    }
  }
  if (pickType.length === 10) {
    return (
      <Tooltip title={`${disabled ? 'Draft' : 'Requested'} shipment`}>
        <div>
          <Chip
            label={pickType}
            chipcolor={disabled ? ChipColor.grey : ChipColor.secondary}
          />
        </div>
      </Tooltip>
    );
  }
  return <></>;
};

export default PickTypeIndicator;
